"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyTranslate = void 0;
var LegacyI18nService_1 = require("./LegacyI18nService");
var checkLanguageResources = function (languageResource, baseLanguageArg) {
    /* eslint-disable */
    var baseLanguage = baseLanguageArg || 'en-US';
    var langs = Object.keys(languageResource);
    var checkingLangs = langs.filter(function (l) { return l !== baseLanguage; });
    var orgKeys = Object.keys(languageResource[baseLanguage]);
    var missingKeys = [];
    checkingLangs.forEach(function (l) {
        missingKeys = [];
        var keysSet = new Set(Object.keys(languageResource[l]));
        orgKeys.forEach(function (orgKey) {
            if (!keysSet.has(orgKey))
                missingKeys.push(orgKey);
        });
        console.warn("Missing keys for language " + l + " is below: \n " + missingKeys.join(',\n') + "\n");
    });
    /* eslint-enable */
};
/**
 * LegacyTranslate helper, base on LegacyI18nService
 *
 * @exports LegacyTranslate
 * @class LegacyTranslate
 */
var LegacyTranslate = /** @class */ (function () {
    function LegacyTranslate(resourceFile) {
        this.translateInstance = new LegacyI18nService_1.LegacyI18nService();
        this.setLanguageResources = this.setLanguageResources.bind(this);
        this.setLang = this.setLang.bind(this);
        this.getLang = this.getLang.bind(this);
        this.format = this.format.bind(this);
        this.setLanguageResources(resourceFile);
    }
    /**
     * Set language for i18n
     *
     * @static
     * @param {string} langCode like 'en'
     * @memberof Translate
     */
    LegacyTranslate.prototype.setLang = function (langCode) {
        this.translateInstance.setLang(langCode);
    };
    /**
     * Get language in i18n
     *
     * @static
     * @memberof Translate
     */
    LegacyTranslate.prototype.getLang = function () {
        return this.translateInstance.getLang();
    };
    /**
     * Translate format function
     *
     * @static
     * @param {string} icuKey the string key use icu format
     * @param {obj} [values=null] the object with key/value
     * @param {string} [locate='']  can like 'en'
     * @param {any} [options=null] some other options
     * @returns translate string
     * @memberof Translate
     *
     * @example
     * // Data
     * Translate.format('Coupon expires at {expires,time,long }', { expires: new Date() })
     * // Currency
     * Translate.format('The price is: {price, number, USD}', { price: 1000.856 }, 'en-US', {
     *      number: {
     *          USD: {
     *              style: 'currency',
     *              currency: 'USD'
     *          }
     *      }
     *  });
     *  // {selectordinal} Format
     *  Translate.format(`It's my cat's {year, selectordinal,
     *          one {#st}
     *          two {#nd}
     *          few {#rd}
     *          other {#th}
     *      } birthday!`, { year: 2 });
     *  // {select} format
     *  Translate.format('{gender, select,
     *          male {He}
     *          female {She}
     *          other {They}
     *          } will respond shortly', { gender: 'male' })
     *  // {selectordinal} Format
     *  Translate.format('You have {numPhotos,plural,
     *      =0 {no photos.}
     *      =1 {one photo.}
     *      other {# photos.}}', { numPhotos: 1000 });
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    LegacyTranslate.prototype.format = function (icuKey, values, locate, options, defaultValue) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var languageResource = this.translateInstance.languageResource;
        var result = this.translateInstance.format(icuKey, values, [languageResource], this.translateInstance.lang);
        if (result !== icuKey)
            return result;
        // to avoid if we still have some new keys which are not ready.
        var enUS = this.translateInstance.format(icuKey, values, [languageResource], 'en-US');
        if (icuKey === enUS && !!defaultValue) {
            return defaultValue;
        }
        if (icuKey === enUS) {
            console.warn("This key is not translate and not have default value:" + icuKey + ". ");
        }
        return enUS;
    };
    LegacyTranslate.prototype.setLanguageResources = function (languageResource, baseLanguage) {
        this.translateInstance.languageResource = languageResource;
        /* eslint-disable */
        if (location.hash.includes('languageCheck=true'))
            checkLanguageResources(languageResource, baseLanguage);
        /* eslint-enable */
    };
    return LegacyTranslate;
}());
exports.LegacyTranslate = LegacyTranslate;
//# sourceMappingURL=LegacyTranslate.js.map